<template>
  <component :is="tag">
    <slot/>
  </component>
</template>

<script>
import tag from '@/js/util/props/tag'
import callback from '@/js/util/props/callback'

export default {
  props: {
    ...tag,
    ...callback,
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      intersectionObserver: undefined,
    }
  },

  watch: {
    options: 'reset',
    callback: 'reset',
  },
  mounted() {
    this.create()
    this.observe()
  },
  methods: {
    create() {
      this.intersectionObserver = new IntersectionObserver(
        ([entry]) => this.callback(entry),
        this.options,
      )
    },
    observe() {
      this.intersectionObserver.observe(this.$el)
    },
    disconnect() {
      this.intersectionObserver.disconnect()
    },
    reset() {
      this.disconnect()
      this.create()
      this.observe()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/BaseIntersection.vue